import React, { Component } from 'react'
import { any } from 'prop-types'
import { Line } from 'react-chartjs-2'

export default class Chart extends Component {
	static propTypes = {
		value: any,
		optionKey: any,
		challenge: any,
		isLD: any
	}
	constructor(props) {
		super(props)
		const { value, optionKey } = this.props
		const processedData = this.processData(value, optionKey)
		this.state = { ...processedData }
	}
	componentWillReceiveProps(nextProps) {
		const { value, optionKey } = nextProps
		const processedData = this.processData(value, optionKey)
		this.setState({ ...processedData })
	}
	processData(value, optionKey) {
		const currentData = []
		const athleteData = []
		const labels = []
		value.forEach(ele => {
			const { athlete, current } = (ele.data[optionKey] || {})
			currentData.push(current || 0)
			athleteData.push(athlete || 0)
			labels.push(ele.weekYear)
		})
		return { currentData, athleteData, labels }
	}
	render() {
		const { currentData, athleteData, labels } = this.state
		const { optionKey, challenge, isLD } = this.props

		const dottedLine = {
			label: challenge && challenge.name ? challenge.name : 'Desafio',
			fill: true,
			borderDash: [10, 10],
			borderWidth: 1,
			backgroundColor: 'rgba(0,0,0,0.05)',
			borderColor: 'grey',
			borderCapStyle: 'butt',
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			pointBorderColor: 'grey',
			pointBackgroundColor: 'grey',
			pointBorderWidth: 0,
			pointHoverRadius: 0,
			pointHoverBackgroundColor: 'grey',
			pointHoverBorderColor: 'rgba(220,220,220,1)',
			pointHoverBorderWidth: 0,
			pointRadius: 0,
			pointHitRadius: 20
		}
		const data = {
			labels,
			datasets: [
				{
					label: 'Acumulado',
					fill: true,
					lineTension: 0.1,
					borderWidth: 1,
					backgroundColor: 'rgba(255, 211, 176,0.60)',
					borderColor: 'rgba(235,104,0,1)',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: 'rgba(235,104,0,1)',
					pointBackgroundColor: 'rgba(235,104,0,1)',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: 'rgba(235,104,0,1)',
					pointHoverBorderColor: 'rgba(220,220,220,1)',
					pointHoverBorderWidth: 2,
					pointRadius: 4,
					pointHitRadius: 20,
					data: athleteData
				},
				{
					label: 'Prescrito',
					fill: true,
					lineTension: 0.1,
					borderWidth: 1,
					backgroundColor: 'rgba(0,0,0,0.15)',
					borderColor: 'rgba(62,61,61,1)',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: 'rgba(62,61,61,1)',
					pointBackgroundColor: 'rgba(62,61,61,1)',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: 'rgba(62,61,61,1)',
					pointHoverBorderColor: 'rgba(220,220,220,1)',
					pointHoverBorderWidth: 2,
					pointRadius: 3,
					pointHitRadius: 20,
					data: currentData
				}
			]
		}
		if (optionKey === 'yield' || optionKey === 'ZIUT' || optionKey === 'difficulty' || optionKey === 'resilience') {
			data.datasets = [data.datasets[0]]
		}
		const options = {
			scales: {
				yAxes: [{
					display: true,
					ticks: {
						beginAtZero: true
					}
				}]
			}
		}
		if (isLD && optionKey === 'averageSpeed') { data.datasets.push({ ...dottedLine, data: new Array(currentData.length).fill(challenge.distance / (challenge.time / 60)) }) }
		return <Line data={ data } options={ options } />
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Chart/Chart.js